import React from 'react';
import { usePermissions } from '../../hooks/usePermissions';
import UpgradePrompt from './UpgradePrompt';

/**
 * Componente que controla el acceso a características según el plan
 * 
 * Uso:
 * <FeatureGate feature="ai_assistant">
 *   <AIAssistantComponent />
 * </FeatureGate>
 */
const FeatureGate = ({ 
    feature, 
    children, 
    fallback,
    requiredPlan,
    plan,
    title,
    description,
    fullPage = false
}) => {
    // Usar 'plan' si fue pasado (como en App.js), sino usar 'requiredPlan', por defecto 'pro'
    const finalRequiredPlan = plan || requiredPlan || 'pro';
    const { hasFeature, loading } = usePermissions();

    if (loading) {
        return (
            <div className="flex items-center justify-center p-8">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
            </div>
        );
    }

    if (!hasFeature(feature)) {
        if (fallback) {
            return fallback;
        }
        
        return (
            <UpgradePrompt 
                feature={feature}
                requiredPlan={finalRequiredPlan}
                title={title}
                description={description}
                fullPage={fullPage}
            />
        );
    }

    return children;
};

export default FeatureGate;
